import { HttpRequest, HttpMethod } from "./http";

class AppCatalogUploadProvider extends HttpRequest {
    presign(payload) {
        return this.request(HttpMethod.Post, "/api/v1/bo/catalog/uploads/presign", payload);
    }
}

export default AppCatalogUploadProvider;
